import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';
import { caseIntegrationMenuItems } from '../shared/models/menus/secured-menu.model';

export const caseIntegrationsRoutes: Routes = [
  {
    path: 'cnesst',
    loadComponent: () => import('./cnesst/cnesst.component').then((m) => m.CnesstComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'saaq',
    loadComponent: () => import('./saaq/saaq.component').then((m) => m.SaaqComponent),
    canActivate: [AuthGuard],
    data: { menuId: caseIntegrationMenuItems.Saaq },
  },
];
